<template>
  <div class="wrapper wrapper-content animated fadeInRight">
    <div class="ibox-content m-b-sm border-bottom">
      <div class="row form-horizontal">
        <div class="ibox-content">
          <div style="padding:8px">Please refer to the color for checking the status of the selected items status on
            this
            page (News/Event/J Channel) :</div>
          <div style="padding:8px"><span class="default colorTip">Grey</span> : The item is in approved status (Once CMS
            published, the item will display on the app);</div>
          <div style="padding:8px"><span class="expiredTip colorTip">Red</span> : The item is Expired (The item will NOT
            display on the app);</div>
          <div style="padding:8px"><span class="statusTip colorTip">Orange</span> : The item is NOT in approved status
            (The item will NOT display on the app. Please approve the item first for display on the app). </div>

          <el-collapse v-model="activeNames">
            <el-collapse-item title="Logo" name="0">

              <div class="form-group">
                <div class="col-sm-10">
                  <el-upload class="upload-demo upload-image" action="#" multiple :http-request="uploadLogo"
                    :auto-upload="true" accept=".png, .jpg , .jpeg" :show-file-list="false">
                    <div slot="tip" v-if="uploadErr" style="color:red;font-size:10px;" class="el-upload__tip">The
                      uploaded
                      file should not exceed 5MB</div>
                    <div class="input-group img-group">
                      <div class="text-center dropzone logo">
                        <div class="addImage" v-if="!landing.logo.showUrl"
                          style="width: 100%; padding-top: 25px; color: #fff">
                          <a class="addImageIcon btn btn-primary btn-circle">
                            <i class="el-icon-upload2"></i>
                          </a>
                          <p class="text-primary m-t-sm font14 suggestFont">
                            <slot name="sizeHint"></slot>
                          </p>
                        </div>
                        <div class="editImage" v-if="landing.logo.showUrl">
                          <div class="mask-bg"></div>
                          <img :src="landing.logo.showUrl" />
                          <div class="icon-center">
                            <span class="edit-icon">
                              <i class="el-icon-edit"></i>
                            </span>
                            <p class="font14 font-white editFont">Modify</p>
                            <p class="text-primary font-white m-t-sm font14 suggestFont">
                              <slot name="sizeHint"></slot>
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </el-upload>
                </div>
              </div>
            </el-collapse-item>
            <el-collapse-item title="Background" name="5">
              <div >Please upload an image of 414 x 560 pixels in size, format: .jpg or .png
              </div>
              <div style="padding-bottom:15px">Please upload 6 background images in sequence for 6 themes used in Mobile App.
              </div>
              <div class="form-group">
                <div class="col-sm-10">
                  <el-upload class="avatar-uploader" :http-request="uploadBackground" :auto-upload="true" :limit="6" :disabled="landing.background.length>=6"
                    accept=".png, .jpg , .jpeg" :show-file-list="true" action="#" list-type="picture-card" :file-list="landing.background">
                    <i slot="trigger" class="el-icon-plus avatar-uploader-icon"></i>
                    <div slot="file" slot-scope="{file}">
                      <img class="el-upload-list__item-thumbnail" :src="file.showUrl || file.url" alt="">
                      <span class="el-upload-list__item-actions">
                        <span class="el-upload-list__item-preview" @click="handlePictureCardPreview(file)">
                          <i class="el-icon-zoom-in"></i>
                        </span>
                        <span class="el-upload-list__item-delete" @click="handleDeleteBackground(file)">
                          <i class="el-icon-delete"></i>
                        </span>
                      </span>

                    </div>
                  </el-upload>
                </div>
              </div>
            </el-collapse-item>
            <!-- <el-upload class="upload-demo upload-image" action="#" multiple :http-request="uploadBackground"
                    :auto-upload="true" accept=".png, .jpg , .jpeg" :show-file-list="false">
                    <div slot="tip" v-if="backgroundUploadErr" style="color:red;font-size:10px;" class="el-upload__tip">
                      The uploaded
                      file should not exceed 5MB</div>
                    <div class="input-group img-group">
                      <div class="text-center dropzone logo">
                        <div class="addImage"
                          v-if="!landing.background || !landing.background.length || !landing.background[0].showUrl"
                          style="width: 100%; padding-top: 25px; color: #fff">
                          <a class="addImageIcon btn btn-primary btn-circle">
                            <i class="el-icon-upload2"></i>
                          </a>
                          <p class="text-primary m-t-sm font14 suggestFont">
                            <slot name="sizeHint"></slot>
                          </p>
                        </div>
                        <div class="editImage" v-else>
                          <div class="mask-bg"></div>
                          <img :src="landing.background[0].showUrl" />
                          <div class="icon-center" style="display: flex;justify-content: center;">
                            <div style="margin-right:60px;">
                              <span class="edit-icon icon-active">
                                <i class="el-icon-edit"></i>
                              </span>
                              <p class="font14 font-white editFont">Modify</p>
                              <p class="text-primary font-white m-t-sm font14 suggestFont">
                                <slot name="sizeHint"></slot>
                              </p>
                            </div>
                            <div class="icon-active" @click.stop = "handleDeleteBackground">
                              <span class="edit-icon icon-active">
                                <i class="el-icon-delete"></i>
                              </span>
                              <p class="font14 font-white editFont">Delete</p>
                              <p class="text-primary font-white m-t-sm font14 suggestFont">
                                <slot name="sizeHint"></slot>
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </el-upload> -->
            <el-collapse-item title="Hero Banner" name="1">
              <div style="padding-bottom:15px">Please add events/J channel in Hero banner Management Section first</div>
              <div class="form-group">
                <div class="col-sm-7">
                  <draggable class="sortable-list connectList0 agile-list"
                    style="max-height: 600px;overflow: auto;margin-bottom: 15px;" v-model="landing.banner"
                    group="people" @start="drag = true" @end="drag = false">
                    <div v-for="(task, index) in landing.banner" :key="index" class="dragObj">
                      <div style="padding: 5px">
                        <span style="display: inline-block;">
                          Name: {{ task["content"] }}
                        </span>
                      </div>
                      <a class="pull-right btn btn-xs btn-white" style="position: absolute;top: 10px;right: 10px;"
                        @click="deleteObj(landing.banner, index)"><i class="el-icon-delete"></i>
                      </a>
                    </div>
                  </draggable>
                  <div class="col-sm-12 text-right pad-b-15">
                    <el-button :disabled="landing.banner.length >= 5" type="primary"
                      @click="selectEvent(landing.banner, 0)">Add Banner
                    </el-button>
                  </div>
                </div>
                <div class="col-sm-5">
                  <el-carousel indicator-position="outside" height="320px" v-if="showSwiper">
                    <el-carousel-item v-for="item in landing.banner" :key="item.id">
                      <video style="width: 100%;" :src="item.url" v-if="item.fileType == 2"
                        :poster="item.imageThumbnailUrl" controls="controls"></video>
                      <el-image v-else style="width: 100%;" :src="item.url"></el-image>
                    </el-carousel-item>
                  </el-carousel>
                </div>
              </div>
            </el-collapse-item>
            <el-collapse-item title="News" name="2">
              <div class="form-group">
                <div class="col-sm-7">
                  <draggable class="sortable-list connectList0 agile-list"
                    style="max-height: 600px;overflow: auto;margin-bottom: 15px;" v-model="landing.publicity"
                    group="people" @start="drag = true" @end="drag = false">
                    <div v-for="(task, index) in landing.publicity" :key="index" class="dragObj"
                      :class="[task.status != 6 && task.status != 5 ? 'statusTip' : '', task.isExpired ? 'expiredTip' : '']">
                      <div style="padding: 5px">
                        <span style="display: inline-block;">Name: {{ task["content"] }}
                        </span>
                      </div>
                      <a class="pull-right btn btn-xs btn-white" style="position: absolute;top: 10px;right: 10px;"
                        @click="deleteObj(landing.publicity, index)"><i class="el-icon-delete"></i>
                      </a>
                    </div>
                  </draggable>
                  <div class="col-sm-12 text-right pad-b-15">
                    <el-button :disabled="landing.publicity.length >= 5" type="primary"
                      @click="selectEvent(landing.publicity, 1)">Add
                      News
                    </el-button>
                  </div>
                </div>
              </div>
            </el-collapse-item>
            <el-collapse-item title="Event" name="3">
              <div class="form-group">
                <div class="col-sm-7">
                  <draggable class="sortable-list connectList0 agile-list"
                    style="max-height: 600px;overflow: auto;margin-bottom: 15px;" v-model="landing.event" group="people"
                    @start="drag = true" @end="drag = false">
                    <div v-for="(task, index) in landing.event" :key="index" class="dragObj"
                      :class="[task.status != 6 && task.status != 5 ? 'statusTip' : '', task.isExpired ? 'expiredTip' : '']">
                      <div style="padding: 5px">
                        <span style="display: inline-block;">Name: {{ task["content"] }}
                        </span>
                      </div>
                      <a class="pull-right btn btn-xs btn-white" style="position: absolute;top: 10px;right: 10px;"
                        @click="deleteObj(landing.event, index)"><i class="el-icon-delete"></i>
                      </a>
                    </div>
                  </draggable>
                  <div class="col-sm-12 text-right pad-b-15">
                    <el-button type="primary" :disabled="landing.event.length >= 6"
                      @click="selectEvent(landing.event, 2)">Add Event
                    </el-button>
                  </div>
                </div>
                <div class="col-sm-5">
                  <el-carousel indicator-position="outside" height="320px" v-if="showSwiper">
                    <el-carousel-item v-for="item in landing.event" :key="item.id"
                      v-if="(item.status == 6 || item.status == 5) && !item.isExpired">
                      <el-image style="width: 100%;" :src="item.url"></el-image>
                    </el-carousel-item>
                  </el-carousel>
                </div>
              </div>
            </el-collapse-item>
            <el-collapse-item title="J-Channel" name="4">
              <div class="form-group">
                <div class="col-sm-7">
                  <draggable class="sortable-list connectList0 agile-list"
                    style="max-height: 600px;overflow: auto;margin-bottom: 15px;" v-model="landing.jChannel"
                    group="people" @start="drag = true" @end="drag = false">
                    <div v-for="(task, index) in landing.jChannel" :key="index" class="dragObj"
                      :class="[task.status != 6 && task.status != 5 ? 'statusTip' : '', task.isExpired ? 'expiredTip' : '']">
                      <div style="padding: 5px">
                        <span style="display: inline-block;">Name: {{ task["content"] }}
                        </span>
                      </div>
                      <a class="pull-right btn btn-xs btn-white" style="position: absolute;top: 10px;right: 10px;"
                        @click="deleteObj(landing.jChannel, index)"><i class="el-icon-delete"></i>
                      </a>
                    </div>
                  </draggable>
                  <div class="col-sm-12 text-right pad-b-15">
                    <el-button type="primary" :disabled="landing.jChannel.length >= 5"
                      @click="selectEvent(landing.jChannel, 3)">Add J-Channel
                    </el-button>
                  </div>
                </div>
                <div class="col-sm-5">
                  <el-carousel indicator-position="outside" height="320px" v-if="showSwiper">
                    <el-carousel-item v-for="item in landing.jChannel" :key="item.id"
                      v-if="(item.status == 6 || item.status == 5) && !item.isExpired">
                      <el-image style="width: 100%;" :src="item.url"></el-image>
                    </el-carousel-item>
                  </el-carousel>
                </div>
              </div>
            </el-collapse-item>
          </el-collapse>
          <div class="form-group">
            <div class="col-sm-12">
              <div class="pull-right">
                <el-button type="primary" @click="submit()">Save and Publish</el-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog :visible.sync="dialogVisible">
      <img width="100%" :src="dialogImageUrl" alt="">
    </el-dialog>
  </div>

</template>

<script>
import eventBus from "../eventbus";
import config from "../config";
import draggable from "vuedraggable";

export default {
  mixins: [config.globalMixin],
  data() {
    return {
      dialogImageUrl: '',
      dialogVisible: false,
      landing: {
        logo: {},
        banner: [],
        event: [],
        jChannel: [],
        news: [],
        publicity: []
      },
      activeNames: [],
      showSwiper: true,
      uploadErr: false,
      backgroundUploadErr: false
    };
  },
  watch: {
    landing: {
      handler: function () {
        this.showSwiper = false;
        var self = this;
        setTimeout(function () {
          self.showSwiper = true;
        })
        this.$store.state.edit = true;
      },
      deep: true
    }
  },
  components: {
    draggable
  },
  created() { },
  methods: {
    async init() {
      var that = this;
      var objdata = this.getAuthObj();
      objdata.apiUrl = this.apiConfig.landingPageDetail;
      let data = await this.$store.dispatch("apiEvent", objdata);
      if (data == "000104") {
        this.timeoutEvent();
        return;
      }
      if (!data) return;
      if (data.data.result.logo && data.data.result.logo.length) {
        data.data.result.logo = data.data.result.logo[0]
      }
      this.landing = data.data.result;
      setTimeout(function () {
        that.$store.state.edit = false;
      }, 500);
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.showUrl || file.url;
      this.dialogVisible = true;
    },
    deleteObj: function (obj, index) {
      obj.splice(index, 1);
    },
    selectEvent: function (obj, type) {
      var that = this;
      this.$store.commit("setlandinglist", {
        callback: function (item) {
          that.$store.commit("setlandinglist", {
            string: "",
            boolean: false
          });
          for (var i = 0; i < item.length; i++) {
            if (type == 2) {
              item[i].id = item[i].eventCode;
            }
            var canPush = true;
            for (var j = 0; j < obj.length; j++) {
              if (obj[j].busId == item[i].id) {
                canPush = false;
              }
            }
            if ((type != 2 && obj.length >= 5) || (type == 2 && obj.length >= 6)) {
              that.$message.error('To enable the function, please ensure the banner number in list no more than 5');
              return;
            }
            if (canPush) {
              obj.push({
                busId: item[i].id,
                content: item[i].title,
                isExpire: item[i].expired,
                status: item[i].status,
                url: item[i].showImageUrl || item[i].showImgUrl || item[i].fileUrl
              });
            }
          }
        },
        boolean: true,
        button: [],
        type: type
      });
    },
    async submit() {
      let obj = this.getAuthObj();
      obj.logo = [];
      obj.logo.push(this.landing.logo.url);
      obj.banner = [];
      this.landing.banner.forEach(function (item) {
        obj.banner.push({
          id: item.busId,
          title: item.content
        })
      })
      obj.publicity = [];
      this.landing.publicity.forEach(function (item) {
        obj.publicity.push({
          id: item.busId,
          title: item.content
        })
      })
      obj.event = [];
      this.landing.event.forEach(function (item) {
        obj.event.push({
          id: item.busId,
          title: item.content
        })
      })
      obj.jChannel = [];
      this.landing.jChannel.forEach(function (item) {
        obj.jChannel.push({
          id: item.busId,
          title: item.content
        })
      })
      obj.background = [];
      this.landing.background.forEach(function (item) {
        obj.background.push(item.content)
      })
      obj.apiUrl = this.apiConfig.landingPageUpdate;
      var data = await this.$store.dispatch("apiEvent", obj);
      if (data == "000104") {
        this.timeoutEvent();
        return;
      }
      if (!data) return;
      this.$message({
        message: 'Save Success',
        type: 'success'
      });
      this.$store.state.edit = false;
    },
    async uploadLogo(params) {
      if (!this.handleCheckUploadFileSize(params.file)) return false
      let obj = this.getAuthObj();
      obj.file = params.file;
      obj.apiUrl = this.apiConfig.upload;
      var data = await this.$store.dispatch("apiEventFromData", obj);
      if (data == "000104") {
        this.timeoutEvent();
        return;
      }
      if (!data) return;
      this.landing.logo.type = 1;
      this.landing.logo.url = data.data.result.url;
      this.landing.logo.showUrl = data.data.result.showUrl;
    },
    async uploadBackground(params) {
      if (!this.handleCheckUploadFileSize(params.file, true)) return false
      let obj = this.getAuthObj();
      obj.file = params.file;
      obj.apiUrl = this.apiConfig.upload;
      var data = await this.$store.dispatch("apiEventFromData", obj);
      if (data == "000104") {
        this.timeoutEvent();
        return;
      }
      if (!data) return;
      if (!this.landing.background || !this.landing.background.length || !this.landing.background[0]) {
        this.landing.background = []
      }
      this.landing.background.push({
        content: data.data.result.url,
        showUrl: data.data.result.showUrl,
        type: 7,
        url: data.data.result.url
      }) 
      this.$forceUpdate()
    },
    handleDeleteBackground(file) {
      for(let i = 0;i<this.landing.background.length;i++){
        if(file.url == this.landing.background[i].url) {
          this.landing.background.splice(i,1)
          this.$forceUpdate()
        }
      }
    },
    handleCheckUploadFileSize(file, isBackground) {
      const sizeKB = file.size / 1024
      if (sizeKB > 5120) {
        isBackground ? this.backgroundUploadErr = true : this.uploadErr = true
        return false
      } else {
        isBackground ? this.backgroundUploadErr = false : this.uploadErr = false
        return true
      }
    }
  },
  mounted() {
    this.init();
  }
};
</script>

<style lang="scss" scoped>
.icon-active:hover {
  color: #1ab394 !important;
}

::v-deep .avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

::v-deep .avatar-uploader .el-upload:hover {
  border-color: #1ab394;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 148px;
  height: 148px;
  line-height: 148px;
  text-align: center;
}

.avatar {
  width: 148px;
  height: 148px;
  display: block;
}
</style>
